/** @jsxImportSource @emotion/react */
import { Container, Link, Stack, Text } from "basis";
import { AccountInfo } from "library/hooks/types";
import { CreditCard } from "../CreditCard/CreditCard";
import { SvgInline } from "../SvgInline/SvgInline";
import { CreditLimitDetails } from "./components/CreditLimitDetails";
import { ScreenProps } from "./types";

export const Approved = ({ state }: ScreenProps) => {
  const accountInfo = state.accountInfo as AccountInfo;
  return (
    <Stack gap="8">
      <Container bg="grey.t05" padding="4">
        <CreditCard
          cardName={accountInfo.cardName}
          cardEndsWith={accountInfo.cardEndsWith}
        />
      </Container>
      <SvgInline name="icon-celebrate" size="120" />
      <Text as="h3" textStyle="heading4">
        Your new credit limit is approved!
      </Text>
      <Text>
        Your new credit limit has been added and you can start shopping right
        away!
      </Text>
      <CreditLimitDetails
        newCreditLimit={state.newCreditLimit}
        accountInfo={accountInfo}
        message={{
          newLimit: "New credit limit",
          newMonthlyPayment: "Minimum monthly payment",
          oldLimit: "Old credit limit",
          oldMonthlyPayment: "Old Minimum monthly payment",
        }}
      />
      <Link
        appearance="primary-button"
        variant="blue-button"
        width="216"
        href="/"
        newTab={false}
      >
        Go to overview
      </Link>
    </Stack>
  );
};
